<template>
  <div class="core">
    <div class="layui-layer-title" style="cursor: move;">{{title}}</div>
      <div class="layui-layer-content">
        <div class="layui-layer-wrap">
          <div class="form-collapse">
            <div class="info">
              <layui-form ref="gsForm" :show-form="true" :after-save="handleAfterSave" :rule="service_form_rule" :requestUniqueId="requestId">
                <template slot-scope="{scope}">
                  <div class="layui-form">
                      <template>
                        <layui-collapse>
                          <div class="layui-colla-item">
                            <h2 class="layui-colla-title">客户基本信息</h2>
                            <div class="layui-colla-content layui-show">
                              <div class="layui-form-item-one">
                                  <pub-form :config="config" @selectArea="changArea"></pub-form>
                              </div>
                            </div>
                          </div>
                        </layui-collapse>
                      </template>
                  </div>
                  <div class="layui-form-btn">
                    <div class="layui-footer">
                      <button class="layui-btn refresh" title="关闭" @click="handleBtnclick('close')">
                        关 闭
                      </button>
                      <button class="layui-btn" title="保存" @click="handleBtnclick('save')">
                        保 存
                      </button>
                    </div>
                  </div>
                </template>
              </layui-form>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      requestId: 'CustomerClientRequest',
      service_form_rule: {
        // MANAGER_ID: {
        //   required: { message: '项目经理不能为空'},
        // },
        CLIENT_NAME: {
          required: { message: '客户名称不能为空'},
        }
      },
      areaArr:[], // 地区数组
      config: {
        render: [
          // { required: true, label: '项目经理',
          //   children: [
          //     { type: 'select', name: 'MANAGER_ID', tableName: 'YW_MANAGER', textField: 'MANAGER_NAME', valueField: 'MANAGER_ID', enableSearch: true, queryCondition: {}, sort: [],}
          //   ]
          // },
          { required: true, label: '客户编号',  hide: true,
            children: [
              {type: 'input', name: 'CLIENT_BH', enabled : true,}
            ]
          },
          { required: true, label: '客户名称',
            children: [
              {type: 'input', name: 'CLIENT_NAME',}
            ]
          },
          { label: '行业类型',
            children: [
              {type: 'select', name: 'INDUSTRY_TYPE', tableName: 'DB_DICTIONARY', textField: 'DIC_NAME', valueField: 'DIC_CODE',enableSearch: true,queryCondition: {'DIC_CATEGORY:0' : '公司客户行业类型', 'DIC_PCODE:3': '-1' }, sort: [],}
            ]
          },
          { label: '联系人姓名',
            children: [
              {type: 'input', name: 'PERSON_NAME',}
            ]
          },
          { label: '联系人电话',
            children: [
              {type: 'input', name: 'PERSON_PHONE',}
            ]
          },
          { label: '所属地',
            children: [
              // {type: 'area', name: 'SSD'}
              {
                type: 'cusCmp',
                name: 'SSD',
              },
            ]
          },
          { label: '地址',
            children: [
              {type: 'input', name: 'ADDRESS',}
            ]
          },
          { label: '备注',
            children: [
              {type: 'textarea', name: 'BZ',}
            ]
          },
        ],
        form: {}
      },
      formData: {},
      formType: 'add',
      title:'',
    }
  },
  mounted () {
    if(this.tabParam) {
      this.formData = this.tabParam.editRow;
      this.tableObj = this.tabParam.tableObj;
      this.formType = this.tabParam.formType;
      this.title = this.tabParam.title;
      if (this.formType === 'edit') {
        if(!Array.isArray(this.formData.SSD)){
          this.formData.SSD = this.formData.SSD.split(',')
        }
        this.config.form = this.formData;
        this.config.render[0].hide = false;
      }
    }
  },
  methods: {
    handleAfterSave() {
      this.baseComponent.closeComponent(this.tabParam.cloneMenu)
      if (this.tabParam.from === 'storeForm') {
        this.baseComponent.currentComponent = this.tabParam.sourceMenu;
      } else {
      this.baseComponent.loadComponentByName('client')
        if (this.tableObj) {
          this.tableObj.pageInfo.pageIndex = 1
          this.tableObj.load()
        }
      }
    },
    changArea(val,fn){
      let arr = []
      fn.forEach(item=>{
        arr.push(item.id)
      })
      this.areaArr = arr
      this.config.form.PROVINCE = this.areaArr[0] ? this.areaArr[0] : '';
      this.config.form.CITY = this.areaArr[1] ? this.areaArr[1] : '';
      this.config.form.DISTRICT = this.areaArr[2] ? this.areaArr[2] : '';
    },
    /**
     * 保存、关闭
     */
    handleBtnclick(type) {
      switch (type) {
        case 'close': {
          this.baseComponent.closeComponent(this.tabParam.cloneMenu);
          if(this.tabParam.from == 'storeForm'){
            this.baseComponent.currentComponent = this.tabParam.sourceMenu;
          }else {
            this.baseComponent.loadComponentByName('client');
          }
          break
        }
        case 'save': {
          if (this.config.form.SSD) {
            // arr = this.config.form.SSD.split(',');
            // this.config.form.PROVINCE = this.areaArr[0] ? this.areaArr[0] : '';
            // this.config.form.CITY = this.areaArr[1] ? this.areaArr[1] : '';
            // this.config.form.DISTRICT = this.areaArr[2] ? this.areaArr[2] : '';
          }
          this.$refs.gsForm.editRow = this.config.form;
          this.$refs.gsForm.callableSave("YW_CUSTOMER_CLIENT");
          break
        }
        default: {
          break
        }
      }
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/person/clientManage/clientForm.vue